import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import PropTypes from 'prop-types';

import CostIcon from '@/svg-icons/costs';

function CostSection({ cost }) {
  if (!cost || Object.keys(cost).length === 0) return null;

  return (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <CostIcon className="text-gray-700 mr-2 w-6 h-6 shrink-0" />
        <FormattedMessage id="cost" />
      </div>

      <div className="flex flex-wrap text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
        <div className="w-1/2 mb-[1vw]" data-cy="order-details-cost-condominium-cost">
          <div className="font-bold">
            <FormattedMessage id="condominiumCost" />
          </div>
          {cost.condominiumCost ? (
            <FormattedNumber
              value={cost.condominiumCost}
              style="currency" // eslint-disable-line react/style-prop-object
              currency="BRL"
            />
          ) : null}
        </div>

        <div className="w-1/2 mb-[1vw]" data-cy="order-details-cost-iptu-cost">
          <div className="font-bold">
            <FormattedMessage id="iptuCost" />
          </div>
          {cost.iptuCost ? (
            <FormattedNumber
              value={cost.iptuCost}
              style="currency" // eslint-disable-line react/style-prop-object
              currency="BRL"
            />
          ) : null}
        </div>

        <div className="w-1/2" data-cy="order-details-cost-rent-cost">
          <div className="font-bold">
            <FormattedMessage id="rentCost" />
          </div>
          {cost.rentCost ? (
            <FormattedNumber
              value={cost.rentCost}
              style="currency" // eslint-disable-line react/style-prop-object
              currency="BRL"
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}

CostSection.propTypes = {
  cost: PropTypes.object.isRequired,
};

export default CostSection;
